import { createIdentifier } from '@wendellhu/redi';

export interface BackendLogService {
  debug(...args: unknown[]): void;
  info(...args: unknown[]): void;
  log(...args: unknown[]): void;
  warn(...args: unknown[]): void;
  error(...args: unknown[]): void;
  deprecate(...args: unknown[]): void;
  child(name: string): BackendLogService;
}

export const IBackendLogService = createIdentifier<BackendLogService>('backend.log');
